import { AppDeleteButton } from "../../components/AppDeleteButton";
import {
  EditContextProvider,
  SaveButton,
  SimpleForm,
  TextInput,
  Title,
  AutocompleteInput,
  useEditController,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useParams } from "react-router-dom";

export const FeedbacksEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "feedbacks/crud",
    id,
    mutationMode: "pessimistic",
  });
  return (
    <>
      <EditContextProvider value={controller}>
        <Title title="Contatos" />
        {/* toolbar={false}: Salvar/Remover ficam no topo, junto do Ver */}
        <SimpleForm toolbar={false}>
          <PageTopBreadcrumb
            title="Contatos"
            firstPath="/#/feedbacks/crud"
            secondTitle="Editando"
            thirdTitle={
              controller && controller.record && controller.record.email
            }
            actionType="show"
            actions={
              <>
                <AppDeleteButton label="Remover" />
                <SaveButton label="Salvar" />
              </>
            }
          />
          <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
            <CardHeader title="Contato" />
            <CardContent>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <TextInput
                    source="id"
                    fullWidth
                    label="ID"
                    disabled
                    helperText={false}
                  />
                  <TextInput
                    source="email"
                    fullWidth
                    label="E-mail"
                    helperText={false}
                  />
                  <TextInput
                    source="message"
                    fullWidth
                    label="Mensagem"
                    multiline
                    helperText={false}
                  />
                  <AutocompleteInput
                    source="type"
                    label="Tipo de contato"
                    helperText={false}
                    choices={[
                      { id: "other", name: "Outro" },
                      { id: "bug", name: "Reportar Bug" },
                      { id: "feature", name: "Solicitar Recurso" },
                      { id: "contact", name: "Contato" },
                      { id: "debit", name: "Débito" },
                      { id: "request", name: "Solicitação de Alteração" },
                    ]}
                    fullWidth
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </SimpleForm>
      </EditContextProvider>
    </>
  );
};
